import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Subscription } from '../../types/Subscription';
import { SubscriptionAccess } from '../../types/Subscription';

interface SubscriptionState {
  subscription: Subscription | null;
}

const initialState: SubscriptionState = {
  subscription: null,
};

export const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    /**
     * Stores the subscription status response from the backend.
     */
    setSubscription: (state, action: PayloadAction<Subscription>) => {
      state.subscription = action.payload;
    },
    /**
     * Clears the subscription data (for example on logout).
     */
    clearSubscription: (state) => {
      state.subscription = null;
    },
  },
});

export const { setSubscription, clearSubscription } = subscriptionSlice.actions;

export const selectSubscription = (state: {
  subscription: SubscriptionState;
}) => state.subscription.subscription;

// Selectors
export const selectAccessLevel = (state: { subscription: SubscriptionState }) =>
  state.subscription.subscription?.accessLevel ?? SubscriptionAccess.FREE;

export default subscriptionSlice.reducer;
